module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row auction"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-jumbotron', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.activeAuction.title,
      "lead": _vm.activeAuction.description
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3 mb-3"
  }, [_c('dashboard-icon-button', {
    attrs: {
      "toName": "liveAuction",
      "buttonTitle": "Start veiling",
      "iconName": "gavel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3 mb-3"
  }, [_c('dashboard-icon-button', {
    attrs: {
      "toName": "itemAdd",
      "buttonTitle": "Kavel",
      "iconName": "plus"
    }
  })], 1), _vm._v(" "), (_vm.financialPermission) ? _c('div', {
    staticClass: "col-sm-6 col-lg-3 mb-3"
  }, [_c('dashboard-icon-button', {
    attrs: {
      "buttonTitle": "Financieël overzicht",
      "iconName": "download",
      "loading": _vm.isDownloading
    },
    on: {
      "click": _vm.downloadOverview
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48e6f15e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Auction.vue
// module id = 1306
// module chunks = 1